import { PropTypes } from 'prop-types';
import React from 'react';

function OutgoingCall(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1573_36754)">
        <path
          d="M12.3088 20.7841L12.3171 20.7899C13.0372 21.2484 13.8921 21.4474 14.7406 21.3543C15.5891 21.2611 16.3804 20.8812 16.9838 20.2774L17.5079 19.7532C17.6241 19.6371 17.7162 19.4993 17.7791 19.3476C17.842 19.1959 17.8743 19.0333 17.8743 18.8691C17.8743 18.7048 17.842 18.5422 17.7791 18.3905C17.7162 18.2388 17.6241 18.101 17.5079 17.9849L15.2971 15.7757C15.181 15.6596 15.0432 15.5674 14.8915 15.5046C14.7398 15.4417 14.5772 15.4093 14.4129 15.4093C14.2487 15.4093 14.0861 15.4417 13.9344 15.5046C13.7827 15.5674 13.6449 15.6596 13.5288 15.7757C13.2944 16.0101 12.9765 16.1417 12.645 16.1417C12.3136 16.1417 11.9957 16.0101 11.7613 15.7757L8.22628 12.2399C7.99194 12.0055 7.86029 11.6876 7.86029 11.3561C7.86029 11.0247 7.99194 10.7068 8.22628 10.4724C8.34244 10.3563 8.43458 10.2185 8.49745 10.0668C8.56032 9.91505 8.59268 9.75244 8.59268 9.58822C8.59268 9.424 8.56032 9.26139 8.49745 9.10968C8.43458 8.95797 8.34244 8.82014 8.22628 8.70406L6.01628 6.49489C5.78187 6.26055 5.46398 6.12891 5.13253 6.12891C4.80107 6.12891 4.48319 6.26055 4.24878 6.49489L3.72378 7.01906C3.1201 7.62254 2.74038 8.41391 2.64735 9.26242C2.55431 10.1109 2.75354 10.9658 3.21211 11.6857L3.21711 11.6941C5.63893 15.2772 8.72518 18.3629 12.3088 20.7841Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M21.375 2.625L13.25 10.75"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M16.375 2.625H21.375V7.625"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_1573_36754">
          <rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

OutgoingCall.propTypes = {
  fill: PropTypes.string.isRequired
};

export default OutgoingCall;
